/* unplugin-vue-components disabled */import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rowClo_box"
};
import { onUpdated } from "vue";
export default {
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    _useCssVars(_ctx => ({
      "2016f19f": _unref(height).slot,
      "647dbdd8": _unref(width).parent
    }));
    const slotRef = ref(null);
    const parentDom = ref(null);
    const parentSize = () => {
      if (!parentDom.value) return;
      const {
        clientWidth,
        clientHeight
      } = parentDom.value;
      height.parent = clientHeight;
      width.parent = clientWidth;
      if (!slotRef.value) return;
      const {
        clientWidth: slotWidth,
        clientHeight: slotHeight
      } = slotRef.value;
      height.slot = slotHeight;
      width.slot = slotWidth;
    };
    onMounted(() => {
      nextTick(() => {
        parentSize();
      });
      window.addEventListener("resize", parentSize);
    });
    onUpdated(() => {
      nextTick(() => {
        parentSize();
      });
    });
    const height = reactive({
      parent: 0,
      slot: 0
    });
    const width = reactive({
      parent: 0,
      slot: 0
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", parentSize);
    });
    __expose({
      parentSize,
      slotRef
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "rowScroll_box",
        ref_key: "parentDom",
        ref: parentDom
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "content_row",
        ref_key: "slotRef",
        ref: slotRef
      }, [_renderSlot(_ctx.$slots, "default")], 512)])], 512);
    };
  }
};